/* IZECOmfort v10 · el pack de la página se marca solo en EasySell, formulario compacto y vídeos con sonido */
(function(){
'use strict';
var d=document;
var RM=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
function $(s,r){return (r||d).querySelector(s);}
function $$(s,r){return [].slice.call((r||d).querySelectorAll(s));}
function play(v){var p=v.play();if(p&&p.catch)p.catch(function(){});}

/* ---------- 1. EasySell: marcar la oferta (1, 2 o 3 cojines) que el cliente eligió en la página ---------- */
var want=0;
var ON_PRODUCT=/\/products\//.test(location.pathname);
var J=null;try{J=JSON.parse(($('[data-izc-json]')||{}).textContent||'null');}catch(_){}
var CODES=window.IZC_PACK_CODES||{3:'BLACKFRIDAY3'};
window.addEventListener('click',function(e){
  var t=e.target&&e.target.closest&&e.target.closest('[data-izc-cod]');if(!t)return;
  var b=$('[data-izc-bundle][aria-checked="true"]');
  want=b?(+b.dataset.qty||1):1;
  var m=d.getElementById('easysell-modal');if(m){m._izcQ=want;m._izcTries=0;}
  var es=d.getElementById('es-popup-button');
  if(!es){
    /* en móvil EasySell puede tardar un poco en cargar: se espera hasta 4 s sin recargar nada;
       si no llega, se abre el formulario propio del tema */
    if(t.dataset.izcFallback){delete t.dataset.izcFallback;return;}
    e.preventDefault();e.stopPropagation();e.stopImmediatePropagation();
    if(t.dataset.izcWait)return;t.dataset.izcWait='1';t.classList.add('is-loading');
    var tries=0;
    (function wait(){
      if(d.getElementById('es-popup-button')){delete t.dataset.izcWait;t.classList.remove('is-loading');t.click();return;}
      if(++tries>40){delete t.dataset.izcWait;t.classList.remove('is-loading');t.dataset.izcFallback='1';t.click();return;}
      setTimeout(wait,100);
    })();
    return;
  }
  e.preventDefault();e.stopPropagation();e.stopImmediatePropagation();
  if(t.dataset.izcBusy)return;t.dataset.izcBusy='1';t.classList.add('is-loading');
  /* se vacía el carrito y se dejan solo los códigos que tocan:
     - en la ficha, EasySell aplica el descuento del pack con sus ofertas, así que no va ningún código (nunca dos descuentos);
     - fuera de la ficha (inicio) EasySell no muestra ofertas, así que el pack lleva su código */
  var code=ON_PRODUCT?'':(CODES[want]||'');
  var H={'Content-Type':'application/json','Accept':'application/json'};
  Promise.all([
    fetch('/cart/clear.js',{method:'POST',headers:H}).catch(function(){}),
    fetch('/cart/update.js',{method:'POST',headers:H,body:JSON.stringify({discount:code})}).catch(function(){})
  ]).then(function(){delete t.dataset.izcBusy;t.classList.remove('is-loading');es.click();});
},true);
/* pago con tarjeta, Apple Pay o Google Pay: el pack lleva su código de descuento al pago */
window.addEventListener('click',function(e){
  var a=e.target&&e.target.closest&&e.target.closest('[data-izc-express]');if(!a||!J||!J.variant)return;
  var b=$('[data-izc-bundle][aria-checked="true"]');if(!b||(b.dataset.variant&&+b.dataset.variant!==+J.variant))return;
  var q=+b.dataset.qty||1,c=CODES[q];if(!c)return;
  e.preventDefault();e.stopImmediatePropagation();
  location.href='/cart/'+J.variant+':'+q+'?discount='+encodeURIComponent(c);
},true);
/* llegada desde el inicio: marcar el pack y abrir el formulario */
(function(){
  var hm=location.hash.match(/^#izc-cod-(\d)/);if(!hm||!ON_PRODUCT)return;
  var n=+hm[1];try{history.replaceState(null,'',location.pathname+location.search);}catch(_){}
  var b=$('[data-izc-bundle][data-qty="'+n+'"]');if(b)b.click();
  var tries=0;
  (function go(){
    if(d.getElementById('es-popup-button')||tries>40){var c=$('.izc-cod[data-izc-cod]')||$('[data-izc-cod]');if(c)c.click();return;}
    tries++;setTimeout(go,150);
  })();
})();
function qOf(c){var t=$('.flex-column > div',c);var m=(t?t.textContent:c.textContent).match(/(\d+)/);return m?+m[1]:0;}
/* la oferta marcada es la única con un estilo distinto a las demás */
function selIndex(cs){
  if(cs.length<2)return 0;
  var st=cs.map(function(c){return (c.getAttribute('style')||'').replace(/\s/g,'');});
  for(var i=0;i<st.length;i++){var n=0;for(var k=0;k<st.length;k++)if(st[k]===st[i])n++;if(n===1)return i;}
  return -1;
}
function offers(){
  var m=d.getElementById('easysell-modal');if(!m)return;
  if(m._izcQ===undefined&&want){m._izcQ=want;m._izcTries=0;}
  var cs=$$('.es-qo-container',m);
  if(!cs.length){lineItem(m);return;}
  m.classList.add('izc-es-v10');m.classList.remove('izc-es-line');
  var q=m._izcQ||0;
  var ti=-1;cs.forEach(function(c,i){if(qOf(c)===q)ti=i;});
  if(ti<0){m.classList.remove('izc-es-one');return;}
  if(selIndex(cs)!==ti&&(m._izcTries||0)<4){m._izcTries=(m._izcTries||0)+1;cs[ti].click();}
  m.classList.add('izc-es-one');
  cs.forEach(function(c,i){c.classList.toggle('izc-qo-on',i===ti);});
}

/* fuera de la ficha EasySell enseña una línea de carrito: se deja igual que la tarjeta del pack (unidades y ahorro, sin precios) */
function eur(c){c=Math.round(c);return (c%100?(c/100).toFixed(2).replace('.',','):String(c/100))+' €';}
function lineItem(m){
  var li=$('.es-line-item',m);if(!li){m.classList.remove('izc-es-line');return;}
  var g=$('.flex-grow-1',li);if(!g)return;
  var q=m._izcQ||want||1,b=$('[data-izc-bundle][data-qty="'+q+'"]');
  var sv=b?(+b.dataset.compare||0)-(+b.dataset.price||0):0;
  var key=q+'|'+sv,box=$('.izc-li',g);
  if(!box||box.dataset.k!==key){
    if(box)box.remove();
    box=d.createElement('div');box.className='izc-li';box.dataset.k=key;
    var tt=d.createElement('b');tt.textContent=q+(q===1?' cojín':' cojines');box.appendChild(tt);
    if(sv>0){var bd=d.createElement('span');bd.className='es-offer-badge izc-li-b';bd.textContent='Ahorras '+eur(sv);box.appendChild(bd);}
    g.insertBefore(box,g.firstChild);
  }
  m.classList.add('izc-es-line');
}

/* ---------- 2. Vídeos con sonido ---------- */
var ICON='<svg class="izc-snd-off" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M11 5L6 9H3v6h3l5 4z" fill="currentColor"/><path d="M22 9l-6 6M16 9l6 6"/></svg><svg class="izc-snd-on" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M11 5L6 9H3v6h3l5 4z" fill="currentColor"/><path d="M15.5 8.5a5 5 0 0 1 0 7M18.5 5.5a9 9 0 0 1 0 13"/></svg><span>Sonido</span>';
function vidOf(b){var f=b.closest('figure')||b.closest('.izc-lb8-box')||b.parentNode;return f?$('video',f):null;}
function setBtn(b,on){if(!b)return;b.classList.toggle('is-on',on);b.setAttribute('aria-pressed',on?'true':'false');b.setAttribute('aria-label',on?'Quitar sonido':'Activar sonido');}
function muteOthers(keep){$$('video').forEach(function(v){if(v!==keep&&!v.muted)v.muted=true;});}
window.addEventListener('click',function(e){
  var b=e.target&&e.target.closest&&e.target.closest('[data-izc-snd]');if(!b)return;
  e.preventDefault();e.stopPropagation();
  var v=vidOf(b);if(!v)return;
  if(v.dataset.src&&!v.getAttribute('src')){v.src=v.dataset.src;}
  if(v.muted){muteOthers(v);v.muted=false;if(!b.classList.contains('izc-lb-snd-b')){try{v.currentTime=0;}catch(_){}}play(v);}
  else{v.muted=true;}
  setBtn(b,!v.muted);
},true);
/* el botón siempre refleja si el vídeo suena (al salir de pantalla vuelve a silencio) */
d.addEventListener('volumechange',function(e){
  var v=e.target;if(!v||v.tagName!=='VIDEO')return;
  var f=v.closest('figure')||v.closest('.izc-lb8-box');var b=f&&$('[data-izc-snd]',f);setBtn(b,!v.muted);
},true);

/* Visor en grande: los vídeos con voz se abren con sonido */
function lbSync(){
  var lb=$('.izc-lb8');if(!lb||!lb.classList.contains('on'))return;
  var v=$('video',lb),src=v.getAttribute('src')||'';if(!src)return;
  var it=$$('[data-izc-lbitem]').filter(function(f){var x=$('video',f);return x&&(x.dataset.src===src||x.getAttribute('src')===src);})[0];
  var snd=!!(it&&it.hasAttribute('data-izc-sound'));
  var box=$('.izc-lb8-box',lb),btn=$('.izc-lb-snd-b',lb);
  if(!btn&&box){btn=d.createElement('button');btn.type='button';btn.className='izc-snd izc-lb-snd-b';btn.setAttribute('data-izc-snd','');btn.innerHTML=ICON;box.appendChild(btn);}
  if(btn)btn.hidden=!snd;
  if(snd&&v._izcSrc!==src){v._izcSrc=src;muteOthers(v);v.muted=false;play(v);}
  if(!snd){v._izcSrc=src;v.muted=true;}
  setBtn(btn,!v.muted);
}
d.addEventListener('click',function(e){
  if(e.target.closest&&e.target.closest('[data-izc-lbitem],.izc-lb8-nav'))setTimeout(lbSync,0);
});
d.addEventListener('play',function(e){if(e.target.closest&&e.target.closest('.izc-lb8'))lbSync();},true);
d.addEventListener('pointerup',function(e){if(e.target.closest&&e.target.closest('.izc-lb8-box'))setTimeout(lbSync,30);},true);
/* al cerrar el visor se olvida el vídeo para que vuelva a sonar la próxima vez */
d.addEventListener('click',function(e){if(e.target.closest&&e.target.closest('.izc-lb8 .izc-x,.izc-lb8-s')){var v=$('.izc-lb8 video');if(v)v._izcSrc='';}});
d.addEventListener('keydown',function(e){if(e.key==='Escape'){var v=$('.izc-lb8 video');if(v)v._izcSrc='';}});

/* ---------- 3. Carrusel de vídeos: flechas en ordenador ---------- */
var ARR='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>';
function navs(){
  $$('.izc-ugc').forEach(function(u){
    var row=$('.izc-ugc-row',u);if(!row||u.dataset.izcNav)return;u.dataset.izcNav='1';
    var mk=function(dir){var b=d.createElement('button');b.type='button';b.className='izc-ugc-nav '+dir;b.setAttribute('aria-label',dir==='prev'?'Vídeos anteriores':'Ver más vídeos');b.innerHTML=ARR;
      b.addEventListener('click',function(){var c=row.firstElementChild,w=c?c.getBoundingClientRect().width+10:200;row.scrollBy({left:dir==='prev'?-w:w,behavior:RM?'auto':'smooth'});});return b;};
    var p=mk('prev'),n=mk('next');u.appendChild(p);u.appendChild(n);
    var upd=function(){var max=row.scrollWidth-row.clientWidth-4;p.hidden=row.scrollLeft<=4;n.hidden=max<=0||row.scrollLeft>=max;var y=row.offsetTop+row.offsetHeight/2;p.style.top=n.style.top=y+'px';};
    row.addEventListener('scroll',function(){requestAnimationFrame(upd);},{passive:true});
    addEventListener('resize',upd);addEventListener('load',upd);upd();
  });
}

function run(){offers();}
navs();run();
if('MutationObserver' in window){
  var q=0;new MutationObserver(function(){if(q)return;q=requestAnimationFrame(function(){q=0;run();});}).observe(d.documentElement,{childList:true,subtree:true,attributes:true,attributeFilter:['style']});
}
})();
